<template>
  <extend-modal :loading="state.loading" :toggle="closeModal" classes="content">
    <div class="create-subaccount">
      <div class="create-subaccount__content">
        <div class="flex-center">
        </div>
        <h1>Edit Subaccount</h1>
        <p class="center">
          Enter a bank account number that matches with a bank name and you’re on
          your way to creating your subaccount
        </p>
        <form v-on:submit.prevent="handleSubmit" action="">
          <InputV2
                  placeholder="Enter NUBAN"
                  type="text"
                  :required="true"
                  v-model="state.nuban.value"
                  :value="account.account_name"
                  :disabled="false"
                  :showInput="true"
                  :maxlength="10"
                  oninvalid="setCustomValidity('Account number must be 10 digits.')"
          />
          <SelectSearch
                  :options="
            bankList.map(({ code, name }) => ({ value: code, text: name }))
          "
                  :onOptionSelected="(value) => state.bankCode = value"
                  :placeholder="account.bank_name || 'Select Bank'"
          />

          <InputV2
                  v-if="state.isVerified"
                  placeholder="Account Name"
                  type="text"
                  :required="true"
                  v-model="state.accountName"
                  :value="state.accountName"
                  :disabled="true"
                  :showInput="true"
                  classes="-mt-3"
          />

          <button
                  v-if="!state.isVerified"
                  :disabled="state.disabled"
                  @click="verifyAccount"
                  class="btn btn--primary"
          >
            Verify Account
          </button>
          <button
                  v-else
                  :disabled="state.disabled"
                  @click="editSubAccount"
                  class="btn btn--primary"
          >
            Save Changes
          </button>

        </form>
      </div>
    </div>
  </extend-modal>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { onMounted, reactive } from "@vue/composition-api";

import InputV2 from "@/components/inputv2.vue";
import Button from "@/components/button.vue";
import Dropdown from "@/components/dropdown.vue";
import SelectSearch from "@/components/selectsearch.vue";
import ExtendModal from "@/components/ExtendModal.vue";

export default {
  metaInfo: {
    title: "Subaccount - Create Subaccount",
  },

  components: {
    Datepicker,
    InputV2,
    Button,
    Dropdown,
    SelectSearch,ExtendModal
  },

  computed: {
    bankList() {
      return this.$store.state.bankList;
    },
  },

  props: {
    closeModal: {
      type: Function,
      default: () => {},
    },
    fetchSubaccounts: {
      type: Function,
      default: () => {},
    },
    account: Object
  },
  setup(props, { root }) {
    const store = root.$store;
    const state = reactive({
      disabled: false,
      nuban: {
        value: "",
        empty: false,
      },
      bankCode: {
        value: "",
        empty: false,
      },
      subaccounts: "",
      isVerified: false,
      accountName: "",
    });

    onMounted(() => {
      fetchSubAccounts();
    });

    const resetState = () => {
      state.nuban.empty = false;
      state.bankCode.empty = false;
    };

    const verifyAccount = () => {
      // prevent modal from closing
      resetState();
      if (state.nuban.value !== "" && state.bankCode.value !== "") {
        state.disabled = true;
        let requestObject = {
          nuban: state.nuban.value,
          bank_code: state.bankCode.value,
        };
        store
          .dispatch("doBankEnquiry", requestObject)
          .then((response) => {
            const { status, data } = response.body;
            if (status == "success") {
              state.isVerified = true;
              state.accountName = data.account_name;
            }
          })
          .catch((error) => {
            root.$notify({
              group: "notifications-default",
              type: "error text-white",
              title: "Error",
              text:
                "Unable to perform a name enquiry. Please check your account details and try again",
            });
          })
          .finally(() => {
            state.disabled = false;
          });
      } else {
        if (state.nuban.value == "") {
          state.nuban.empty = true;
        }
        if (state.bankCode.value == "") {
          state.bankCode.empty = true;
        }
      }
    };

    const editSubAccount = () => {
      // prevent modal from closing
      resetState();
      if (state.nuban.value !== "" && state.bankCode.value !== "") {
        state.disabled = true;
        let requestObject = {
          id: root.$route.params.id,
          nuban: state.nuban.value,
          bank_code: state.bankCode.value,
        };

        store
          .dispatch("updateSubAccount", requestObject)
          .then((response) => {
            // Show success
            root.$notify({
              group: "notifications-default",
              type: "success text-white",
              title: "Success",
              text: response.body.message,
            });
            clearData();
            props.closeModal();
            props.fetchSubaccounts();

          })
          .catch((error) => {
            state.disabled = false;
            root.$notify({
              group: "notifications-default",
              type: "error text-white",
              title: "Error",
              text: error.body.message,
            });
          });
      } else {
        if (state.nuban.value == "") {
          state.nuban.empty = true;
        }
        if (state.bankCode.value == "") {
          state.bankCode.empty = true;
        }
      }
    };

    const fetchSubAccounts = () => {
      store
        .dispatch("getSubAccountDetails", { id: props.account.account })
        .then((response) => {
          console.log(props.account, 'props.account')
          if (response.body.data && response.body.data.subaccounts.length > 0) {
            console.log(response.body.data, 'response.body.data.')
            loadEdit(response.body.data.subaccounts[0]);
            // this.emptyState = false;
            // this.loading = false;
          } else {
            // this.emptyState = true;
            // this.loading = false;
          }
        })
        .catch((error) => {
          // LOG Error
          root.$notify({
            group: "notifications-default",
            type: "error text-white",
            title: "Error",
            text: error.body.message,
          });
        });
    };

    const loadEdit = (value) => {
      // load data
      state.nuban.value = value.nuban;
      state.bankCode.value = value.bank_code;
    };

    const clearData = () => {
      state.nuban.value = "";
      state.bankCode.value = "";
      state.accountName = "";
    };

    const copyToClipboard = () => {
      // 1) Add the text to the DOM (usually achieved with a hidden input field)
      let input = document.createElement("input");
      document.body.appendChild(input);
      input.value = state.subaccounts;

      // 2) Select the text
      input.focus();
      input.select();

      // 3) Copy text to clipboard
      let isSuccessful = document.execCommand("copy");

      // 4) delete input
      document.body.removeChild(input);
    };

    return {
      verifyAccount,
      resetState,
      state,
      clearData,
      copyToClipboard,
      fetchSubAccounts,
      editSubAccount,
    };
  },
};
</script>
<style lang="scss" scoped>
.nuban {
  padding: 100px 25px 120px;
  text-align: center;
  &__number {
    color: #e8368f;
    font-size: 32px;
    line-height: 35px;
    padding: 19px 28px 15px;
    background-color: rgba(#e8368f, 0.15);
    border-radius: 16px;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 32px;
    position: relative;
  }

  &__title {
    color: #261940;
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 16px;
  }

  &__caption {
    color: rgba(#261940, 0.8);
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 32px;
  }

  &__copy {
    position: absolute;
    color: #e00b5b;
    font-size: 12px;
    line-height: 13px;
    top: -20px;
    right: 0;
    cursor: pointer;
  }
}
  .-mt-3{
    margin-top: -31px;
  }
</style>